import React, { useEffect } from "react";
import BrochureProvider from "../components/BrochureProvider";
import Header from "../components/Header";
import Hero from "../components/Hero";
import CapacityBoard from "../components/CapacityBoard";
import PathFinder from "../components/PathFinder";
import FactoryBand from "../components/FactoryBand";
import EnquiryProvider from "../components/EnquiryProvider";
import CollectionsDance from "../components/CollectionsDance";
import About from "../components/About";
import Capabilities from "../components/Capabilities";
import Machinery from "../components/Machinery";
import ExploreCards from "../components/ExploreCards";
import Collection from "../components/Collection";
import Clients from "../components/Clients";
import News from "../components/News";
import Certifications from "../components/Certifications";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import ChatWidget from "../components/ChatWidget";
import SplashIntro from "../components/SplashIntro";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BrochureProvider>
    <EnquiryProvider>
      <SplashIntro />
      <Header />
      <Hero />
      <PathFinder />
      <CapacityBoard />
      <CollectionsDance />
      <About />
      <Capabilities />
      <FactoryBand />
      <Machinery />
      <ExploreCards />
      <Collection />
      <Clients />
      <News />
      <Certifications />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
    </EnquiryProvider>
    </BrochureProvider>
  );
}
